<template>
	<div class="col-lg-3 col-sm-12 spotlight">
		<div class="card mb-3">
			<b-form @submit.prevent="saveContainer" @reset.prevent="$router.push({ name: 'container-view', params: { id: recordId }})">
				<div class="card-header pb-2 pt-2">
					<span>Container Info</span>
				</div>
				<div class="list-group list-group-flush">
					<div class="list-group-item pt-1 pb-1">
					<span>
						<b-button type="submit" variant="primary">Save</b-button>
					</span>
					<span class="float-right">
						<b-button type="reset" variant="secondary">Cancel</b-button>
					</span>
					</div>
				</div>
				<div class="card-body">
					<div class="row job-row">
						<div class="col-12">
							<div><strong>Container Name</strong></div>
							<ValidationProvider v-slot="v" ref="Container Name">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Container Name']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Pallet</strong></div>
							<ValidationProvider v-slot="v" ref="Pallet">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData.Pallet"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Type</strong></div>
							<ValidationProvider v-slot="v" ref="Container Type">
								<v-select
											   v-model="record.fieldData['Container Type']"
											   :options="containerTypes"></v-select>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Pkg Wt</strong></div>
							<ValidationProvider v-slot="v" ref="Package Weight">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Package Weight']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Net Wt</strong></div>
							<ValidationProvider v-slot="v" ref="Net Weight">
								<b-form-input class="form-control job-field"
											  v-model="record.fieldData['Net Weight']"/>
							</ValidationProvider>
						</div>
						<div class="col-12">
							<div><strong>Gross Wt</strong></div>
							<div class="job-field">{{grossWeight}}</div>
						</div>
						<div class="col-12">
							<div><strong>Gross UoM</strong></div>
							<ValidationProvider v-slot="v" ref="Gross UoM">
								<v-select v-model="record.fieldData['Gross UoM']"
											   :options="UoMs"></v-select>
							</ValidationProvider>
						</div>
					</div>
				</div>
			</b-form>
		</div>
	</div>
</template>

<script>
import BaseEdit from '../BaseEdit'
import feedbackMixin from '../../mixins/feedback'
import router from '../../router'

export default {
	name: "ContainerEdit",
	extends: BaseEdit,
	mixins: [feedbackMixin],
	data() {
		return {
			validationRefs: ['Container Name', 'Pallet', 'Container Type', 'Package Weight', 'Net Weight', 'Gross UoM'],
			containerTypes: [],
			UoMs: []
		}
	},
	beforeRouteEnter: function (to, from, next) {
		console.log('From route ' + from.name);
		if (from.name !== 'container-view' && from.name !== 'job-view') {
			router.replace({name: 'container-view', params: to.params})
		} else {
			next()
		}
	},
	beforeRouteUpdate: function (to, from, next) {
		console.log('From route ' + from.name);
		if (from.name !== 'container-view' && from.name !== 'job-view') {
			this.$router.replace({name: 'container-view', params: to.params})
		} else {
			next()
		}
	},
	created() {
		let that = this
		Promise.all([this.getContainerTypes(), this.getUoMs()])
			.then(function (results) {
				that.containerTypes = results[0].data.valueList
				that.UoMs = results[1].data.valueList
			});
	},
	methods: {
		saveContainer() {
			let dirtyFields = {}
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if(validationProvider.flags.dirty) {
					dirtyFields[value] = this.record.fieldData[value]
				}
			})
			this.save({fieldData:dirtyFields})
		},
		getContainerTypes() {
			return this.getValueList("Container Type", "container")
		},
		getUoMs() {
			return this.getValueList("UoM Container", "container")
		}
	},
	computed: {
		grossWeight() {
			let netWeight = this.record.fieldData['Net Weight'];
			let packageWeight = this.record.fieldData['Package Weight'];
			return Number.parseInt(netWeight ? netWeight : 0) + Number.parseInt(packageWeight ? packageWeight : 0);
		}
	},
}
</script>